import { lazy } from "react";
import LazyRoute from "../components/Common/LazyRoute";
import ROUTES from "./ROUTES";

const PaymentProcess = lazy(() => import("../components/Payment/Payment"));
const PaymentSuccess = lazy(() => import("../components/Payment/Success"));
const PaymentFailed = lazy(() => import("../components/Payment/Failed"));

export default [
  { path: ROUTES.PAYMENTS.PROCESS, element: <LazyRoute><PaymentProcess /></LazyRoute> },
  { path: ROUTES.PAYMENTS.SUCCESS, element: <LazyRoute><PaymentSuccess /></LazyRoute> },
  { path: ROUTES.PAYMENTS.FAILED, element: <LazyRoute><PaymentFailed /></LazyRoute> },
];
